import React from 'react';
import { useDynamicFormDrawerStyles } from './style';
import {
  IDynamicFormWidgetSection,
  InitialMultiAutocompleteSearch,
  OnAutocompleteSearch,
  OnFieldBlur,
  OnFieldChange,
} from './types';
import DynamicFormInput from './DynamicFormInput';
import { BooleanRecord, IAbstractRecord } from '@models';

interface IDynamicFormWidgetSectionProps extends IDynamicFormWidgetSection {
  onFieldChange: OnFieldChange;
  onFieldBlur: OnFieldBlur;
  sectionIndex: number;
  disableForm: boolean;
  loadingFields: Record<string, boolean | BooleanRecord>;
  onAutocompleteSearch: OnAutocompleteSearch;
  initialMultiAutocompleteSearch: InitialMultiAutocompleteSearch;
  values: IAbstractRecord;
  errors: IAbstractRecord;
  touched: IAbstractRecord;
}

const DynamicFormSection: React.FC<IDynamicFormWidgetSectionProps> = ({
  sectionTitle,
  inputs,
  sectionIndex,
  onFieldChange,
  onFieldBlur,
  onAutocompleteSearch,
  initialMultiAutocompleteSearch,
  disableForm,
  loadingFields,
  values,
  errors,
  touched,
}) => {
  const { classes } = useDynamicFormDrawerStyles();

  return (
    <section key={sectionTitle} className={classes.section}>
      {sectionTitle && (
        <div className={classes.sectionTitle}>
          <p className={classes.sectionTitleText}>{sectionTitle}</p>
          <hr className={classes.sectionTitleLine} />
          <br />
        </div>
      )}
      {Object.values(inputs).map((input) => (
        <DynamicFormInput
          key={input.name}
          onFieldChange={onFieldChange}
          onFieldBlur={onFieldBlur}
          loadingFields={loadingFields}
          sectionIndex={sectionIndex}
          onAutocompleteSearch={onAutocompleteSearch}
          initialMultiAutocompleteSearch={initialMultiAutocompleteSearch}
          values={values}
          errors={errors}
          touched={touched}
          disabled={input.disabled || disableForm}
          {...input}
        />
      ))}
    </section>
  );
};

export default DynamicFormSection;
